/* eslint-disable one-var */

export const requestsNeededTotal = 30;
// 20 minutes in ms
export const wishlistCacheLifespan = 1200000;
